import {
  Draft,
  EVENT_DELETE_DRAFT,
  EVENT_SET_DRAFT,
  EventDeleteDraftPayload,
} from '@weblite/ts-action/draft'

import { serverSub } from '$func/subscription'
import { draftsStorage } from './storage'
import { currentDrafts } from '$comp/_app/components/chat/components/footer/components/send-field/react-hooks'

serverSub.subscribe(EVENT_SET_DRAFT, (data: unknown) => {
  const draft = data as Draft
  const currentDraft = currentDrafts.get(draft.roomId)
  if (currentDraft && currentDraft.date > draft.date) {
    return
  }
  draftsStorage.add(draft)
})

serverSub.subscribe(EVENT_DELETE_DRAFT, (data: unknown) => {
  const deletePayload = data as EventDeleteDraftPayload
  const { roomId } = deletePayload
  draftsStorage.del(roomId)
})
